import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import Slider from "react-slick";

//slick slider for images slider
function SlickForScreenshots({screenshotContent, dataSettings}) {
  const settings = {
    dots: false,
    // infinite: true,
    autoplay: true,
    slidesToShow: 4,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const settingsNew = {
    dots: false,
    // infinite: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const settingsLeft = {
    dots: false,
    // infinite: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 2,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
   
      <div className="row">
          <div className="col-12">
            {dataSettings === 50 ? (
              <Slider {...settingsNew} className="slick-slider-tram">
              {Array.isArray(screenshotContent) && screenshotContent.map((screenshotContentItem,index) => (
                      <div className='item' key={index}>
                          <img src={screenshotContentItem} />
                      </div>
                      
                    ))}
              </Slider>
            ):(
              dataSettings === 'left' ? (
                <Slider {...settingsLeft} className="slick-slider-tram">
              {Array.isArray(screenshotContent) && screenshotContent.map((screenshotContentItem,index) => (
                      <div className='item' key={index}>
                          <img src={screenshotContentItem} />
                      </div>
                      
                    ))}
              </Slider>
              ) :(
                <Slider {...settings} className="slick-slider-tram">
                {Array.isArray(screenshotContent) && screenshotContent.map((screenshotContentItem,index) => (
                        <div className='item' key={index}>
                            <img src={screenshotContentItem} />
                        </div>
                        
                      ))}
                </Slider>
              )
              
            )}
          </div>
      </div>
   
  );
}

export default SlickForScreenshots;